import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Grid, Card, InputLabel, MenuItem, Select, Button, Typography, Box
} from '@mui/material';
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { CustomSelect, AutoComplete } from 'admin/components/atoms';
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import SoftButton from 'components/SoftButton';
import { DATA_LIMIT } from 'utils/api';

const optionSchema = Yup.object({
    label: Yup.string().required('Label is required'),
    value: Yup.string().required('Value is required'),
}).required('required');

const validationSchema = Yup.object({
    keywordName: Yup.string().required('Keyword name is required'),
    category: Yup.array()
        .of(optionSchema)
        .min(1, 'At least one category is required')
        .required('Category is Required'),
});

const CreateKeywordForm = () => {
    const [preview, setPreview] = useState(null);
    const [categoryData, setCategoryData] = useState([]);
    const params = useParams()
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            keywordName: '',
            category: [],
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const payload = {
                    name: values.keywordName,
                    categories: values?.category?.map((item) => item.value),
                };

                const response = params?.id
                    ? await service.keywords.edit(params.id, payload)
                    : await service.keywords.add(payload);
                if ([200, 201].includes(response.status)) {
                    toast.success(response?.data?.message || 'Keyword saved successfully.');
                    navigate(-1);
                } else {
                    toast.error(response?.data?.message || 'Failed to save keyword.');
                }
            } catch (error) {
                const errMsg = error?.response?.data?.message || 'Something went wrong while submitting.';
                toast.error(errMsg);
                console.error('Submission error:', error);
            }
        },

    });

    const getAllCategory = async (value='') => {
        try {
            const response = await service.categories.view({limit:DATA_LIMIT,searchData:value});
            if (response?.data?.data) {
                setCategoryData(
                    response.data.data.map((item) => ({
                        ...item,
                        label: item.name,
                        value: item._id,
                    }))
                );
            }

        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
    };
    const getDetailById = async () => {
        try {
            const res = await service.keywords.getDetailById(params.id);

            formik.setValues({
                keywordName: res.data.data.name || '',
                category: res?.data?.data?.categories?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item._id,
                })) || [],  // wrap in array if needed
            });
        } catch (error) {
            console.error("Failed to fetch keyword detail:", error);
        }
    };

    useEffect(() => {
        getAllCategory()
        if (params?.id) {
            getDetailById()
        }
    }, [])
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox mt={3}>
                <Card className="glassmorphism-card"
                    sx={{
                        // width: 470,
                        //  minHeight:'600px',
                        display: "flex",
                        flexDirection: "column",
                        padding: 2,
                        boxShadow: 2,
                        overflow: 'visible',
                        position: 'relative',

                    }}>
                    <SoftTypography variant="h6" fontWeight="bold" mb={2}>Create Keywords</SoftTypography>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Enter keyword<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <SoftInput
                                    name="keywordName"
                                    placeholder="Enter keyword"
                                    value={formik.values.keywordName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    multiSelect={true}
                                    error={formik.touched.keywordName && Boolean(formik.errors.keywordName)}
                                />
                                {formik.touched.keywordName && formik.errors.keywordName && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.keywordName}
                                    </SoftTypography>
                                )}
                            </Grid>



                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Select Category<span style={{ color: 'red' }}>*</span></SoftTypography>

                                <AutoComplete
                                    fullWidth
                                    name="category"
                                    options={categoryData}
                                    placeholder= {"Search Category..."}
                                    value={formik.values.category}
                                    onChange={(e, value) => formik.setFieldValue('category', value)}
                                    onBlur={() => formik.setFieldTouched('category', true)}
                                    onInputChange={(value) => {
                                        getAllCategory(value);  // trigger debounced API call
                                    }}
                                    error={formik.touched.category && Boolean(formik.errors.category)}
                                    invalid={formik.touched.category && Boolean(formik.errors.category)}
                                    multiple={true}
                                />

                                {formik.touched.category && formik.errors.category && (
                                    <SoftTypography variant="caption" color="error " sx={{ color: 'red' }}>
                                        {formik.errors.category}
                                    </SoftTypography>
                                )}
                            </Grid>

                            <Grid item xs={12} display="flex" gap={2}>
                                <SoftButton type="submit" variant="gradient" color="info">Submit</SoftButton>
                                {/* <Button variant="outlined" onClick={()=> navigate(-1)}>Cancel</Button> */}
                                <SoftButton
                                    variant="outlined"
                                    color="info"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </SoftButton>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </SoftBox>
        </DashboardLayout >
    );
};

export default CreateKeywordForm;
